import type { typePermission } from '@/features/roles/consts/permissions'

export enum TypeAccount {
  admin = 'admin',
  user = 'user',
  advisor = 'advisor'
}

export interface IUser {
  _id: string
  id: string
  fullname: string
  email: string
  username: string
  password?: string
  typeAccount: TypeAccount
  avatar?: string | null
  isTwoFactorAuthenticationEnabled?: boolean
  mfaRequired?: boolean
  active?: boolean
  roles?: []
}

export interface IAdvisor {
  _id: string
  id: string
  /**
   * El `usr_` con el que v2 direcciona este asesor. Viaja al lado del `_id` para que
   * un select pueda quedarse en este lookup y aun así resolver lo elegido a una
   * referencia v2, cruzando por clave primaria del mismo documento. Ver ADR 0027.
   *
   * Opcional porque el schema lo declara así: un registro anterior al backfill no lo
   * tiene, y quien traduce debe FALLAR en vez de mandar `undefined`.
   */
  publicId?: string | null
  fullname: string
  /** Lo que el filtro "Asesor" de los listados manda como valor. */
  username: string
}

export interface IStatePermission {
  stateId: string
  permissions: string[]
}

export interface IUserAuth {
  _id: string
  accessToken: string
  id: string
  /** ID público canónico (`usr_`) de la sesión staff v2. */
  publicId?: string
  username: string
  fullname: string
  permissions?: typePermission[]
  statePermissions?: IStatePermission[]
  typeAccount: TypeAccount
  /** Access JWT v2 canónico; `accessToken` sigue siendo el bridge v1 durante el strangler. */
  v2AccessToken?: string
  v2SessionId?: string
  mfa?: {
    verified: boolean
    enrolled: boolean
    required: boolean
    verifiedAt: string | null
  }
}

export interface IUserCredentials {
  username: string
  password: string
  persist?: boolean
}

export interface IUserForgotPassword {
  email: string
  username: string
}

export interface IUserResetPassword {
  password: string
  confirmPassword: string
}

export interface IUserLogin {
  tokens: {
    accessToken: string
  }
  user: {
    id: string
    username: string
    fullname: string
    permissions: []
    typeAccount: TypeAccount
  }
}
